export default "__VITE_ASSET__CJRpiI3d__"